export const common = {
  // Navigace
  'nav.home': 'Domů',
  'nav.services': 'Služby',
  'nav.membership': 'Členství',
  'nav.memberZone': 'Členská zóna',
  'nav.partner': 'Partner',
  'nav.cart': 'Košík',
  'nav.myAccount': 'Můj účet',
  'nav.login': 'Přihlásit se',
  'nav.pricing': 'Ceník',
  'nav.contact': 'Kontakt',
  
  // Hero
  'hero.badge': 'VyŽehlené',
  'hero.title': 'Vyžehlené. Vracíme vám čas.\nProtože čas je luxus.',
  'hero.subtitle': 'Prémiové ruční žehlení,\nkteré dělají skuteční lidé s péčí, klidem a respektem.\nKaždý kus oblečení projde rukama lidí,\npro které je práce smyslem, ne pásovou výrobou.\nRuční žehlení od lidí, kteří vědí, že kvalita se nedá uspěchat.',
  
  // Hero - kopie pro překlad
  'hero.badge_copy': 'VyŽehlené',
  'hero.title_copy': 'Vyžehlené. Vracíme vám čas.\nProtože čas je luxus.',
  'hero.subtitle_copy': 'Prémiové ruční žehlení, které dělají skuteční lidé s péčí,klidem a respektem.',
  'hero.description1_copy': 'Každý kus oblečení projde rukama lidí, kteří vědí, že kvalita se nedá uspěchat.',
  'hero.description2_copy': 'Ruční žehlení od lidí, kteří vědí, že kvalita se nedá uspěchat.',
  
  // Ruční práce blok
  'handwork.title': 'Ruční práce má hodnotu',
  'handwork.text1': 'Ve Vyžehlené věříme, že některé věci se mají dělat pomalu.',
  'handwork.text2': 'Proto spolupracujeme s lidmi, pro které je ruční práce přirozená. S rodiči na rodičovské,aktivními seniory nebo lidmi se zdravotním omezením.',
  'handwork.text3': 'Ne proto, že by to bylo levnější.',
  'handwork.text4': 'Ale proto, že je to lepší.',
  
  // Ruční práce blok - kopie pro překlad
  'handwork.title_copy': 'Ruční práce má hodnotu',
  'handwork.text1_copy': 'Ve Vyžehlené věříme, že některé věci se mají dělat pomalu.',
  'handwork.text2_copy': 'Proto spolupracujeme s lidmi, pro které je ruční práce přirozená. S rodiči na rodičovské,aktivními seniory nebo lidmi se zdravotním omezením.',
  'handwork.text3_copy': 'Ne proto, že by to bylo levnější.',
  'handwork.text4_copy': 'Ale proto, že je to lepší.',
  
  // Důvěryhodnost
  'trust.customers': 'Spokojených zákazníků',
  'trust.items': 'Vyžehlených kusů',
  'trust.cities': 'Měst',
  'trust.rating': 'Průměrné hodnocení',
  
  // Služby
  'services.title': 'Naše služby',
  'services.subtitle': 'Profesionální žehlení pro všechny typy oblečení',
  'services.shirts': 'Košile a halenky',
  'services.shirtsDesc': 'Dokonalé vyžehlení košil, halenek a společenských košil',
  'services.pants': 'Kalhoty a sukně',
  'services.pantsDesc': 'Profesionální žehlení kalhot, džín a sukní',
  'services.bedding': 'Ložní prádlo',
  'services.beddingDesc': 'Žehlení prostěradel, povlečení a povlaků na polštáře',
  'services.delicate': 'Jemné látky',
  'services.delicateDesc': 'Šetrná péče o hedvábí, krajky a další jemné materiály',
  
  // Stránka služeb - PŘIDÁNO
  'services.hero.title': 'Naše služby žehlení',
  'services.hero.subtitle': 'Profesionální péče o vaše oblečení',
  'services.hero.cta': 'Zobrazit ceník',
  
  // SEO metadata - PŘIDÁNO
  'seo.services.title': 'Služby žehlení Praha | VyŽehlené - Profesionální žehlení a doprava',
  'seo.services.description': 'Kompletní nabídka služeb žehlení v Praze a Staré Boleslavi. Profesionální žehlení košil, kalhot, ložního prádla a krejčovské úpravy. Doprava zdarma. Transparentní ceník.',
  'seo.services.keywords': 'žehlení Praha, služby žehlení, ceník žehlení, krejčovské úpravy, doprava prádla, profesionální žehlení',
  
  // SEO - Hlavní stránka
  'seo.home.title': 'VyŽehlené Praha | Profesionální ruční žehlení s dovozem a svozem zdarma',
  'seo.home.description': 'VyŽehlené nabízí profesionální ruční žehlení v Praze a Staré Boleslavi. Svoz a rozvoz prádla, členské plány se slevou až 30%, expresní dodání do 24h. Objednejte online.',
  'seo.home.keywords': 'žehlení Praha, ruční žehlení, svoz prádla Praha, profesionální žehlení, VyŽehlené, žehlení Stará Boleslav',

  // SEO - O nás
  'seo.about.title': 'O nás | VyŽehlené Praha - Ruční žehlení s příběhem a hodnotami',
  'seo.about.description': 'Poznejte tým VyŽehlené. Spolupracujeme s lidmi, pro které je ruční práce přirozená. Kvalitní žehlení v Praze a Staré Boleslavi s individuálním přístupem a péčí o každý detail.',
  'seo.about.keywords': 'o nás VyŽehlené, tým žehlení Praha, ruční práce, profesionální žehlení, příběh VyŽehlené',

  // SEO - Členství
  'seo.membership.title': 'Členské plány | VyŽehlené Praha - Ušetřete až 30% na žehlení',
  'seo.membership.description': 'Členské plány VyŽehlené: BASIC, PREMIUM a VIP. Slevy 15-30% na žehlení, prioritní zpracování, expresní dodání a doprava zdarma. Vyberte si plán a začněte šetřit.',
  'seo.membership.keywords': 'členství žehlení, slevy na žehlení Praha, VIP žehlení, členské plány, věrnostní program žehlení',

  // SEO - Košík
  'seo.cart.title': 'Nákupní košík | VyŽehlené Praha - Objednejte žehlení online',
  'seo.cart.description': 'Dokončete objednávku žehlení online. Transparentní ceník, flexibilní časy vyzvednutí, členské slevy. Svoz a rozvoz prádla v Praze a Staré Boleslavi.',
  'seo.cart.keywords': 'objednávka žehlení, košík žehlení Praha, online objednávka prádla, svoz prádla',

  // SEO - Partner
  'seo.partner.title': 'Staňte se partnerem | VyŽehlené - Smysluplná práce s flexibilním úvazkem',
  'seo.partner.description': 'Hledáme partnery pro žehlení prádla po celé ČR. Flexibilní práce, férové podmínky, pravidelný příjem. Staňte se součástí VyŽehlené a dělejte práci, která dává smysl.',
  'seo.partner.keywords': 'partner žehlení, práce z domova, flexibilní práce, žehlení prádla partner, VyŽehlené partner',

  // SEO - Flexibilní vyzvedávání
  'seo.flexPickup.title': 'Flexibilní vyzvednutí prádla | VyŽehlené Praha - Ráno i večer',
  'seo.flexPickup.description': 'Flexibilní hodiny vyzvednutí prádla v Praze. Ranní svoz 7:00-8:30, večerní 18:00-20:00. Vyzvednutí v práci možné. 100% diskrétní služba pro zaneprázdněné klienty.',
  'seo.flexPickup.keywords': 'flexibilní vyzvednutí prádla, svoz prádla ráno, vyzvednutí večer, žehlení Praha, služba pro zaneprázdněné',

  // SEO - Obchodní podmínky
  'seo.terms.title': 'Obchodní podmínky | VyŽehlené Praha - Služba žehlení prádla',
  'seo.terms.description': 'Obchodní podmínky služby žehlení VyŽehlené. Pravidla objednávání, ceník, platební podmínky, storno podmínky, reklamace a ochrana osobních údajů.',
  'seo.terms.keywords': 'obchodní podmínky žehlení, pravidla služby, platební podmínky, storno podmínky, reklamace',

  // SEO - Storno podmínky
  'seo.cancellation.title': 'Storno podmínky | VyŽehlené Praha - Zrušení objednávky žehlení',
  'seo.cancellation.description': 'Storno podmínky služby VyŽehlené. Zrušení zdarma více než 24h před svozem. Storno poplatek 100% méně než 24h. Změna termínu, výjimečné situace.',
  'seo.cancellation.keywords': 'storno podmínky žehlení, zrušení objednávky, storno poplatek, změna termínu svozu',

  // SEO - Zpracování osobních údajů
  'seo.privacy.title': 'Zpracování osobních údajů | VyŽehlené Praha - GDPR ochrana dat',
  'seo.privacy.description': 'Zpracování osobních údajů v souladu s GDPR. Informace o správci údajů, účelu zpracování, době uchovávání, vašich právech a zabezpečení osobních dat.',
  'seo.privacy.keywords': 'zpracování osobních údajů, GDPR, ochrana dat, osobní údaje žehlení, práva subjektu údajů',

  // Stránka služeb
  'servicesPage.hero.title': 'Naše služby žehlení',
  'servicesPage.hero.subtitle': 'Profesionální péče o vaše oblečení',
  'servicesPage.coverage.title': 'Pokrytí oblastí',
  'servicesPage.coverage.subtitle': 'Poskytujeme služby v těchto lokalitách',
  'servicesPage.coverage.prague': 'Praha',
  'servicesPage.coverage.pragueDesc': 'Celá Praha a okolí',
  'servicesPage.coverage.staraBoleslav': 'Stará Boleslav',
  'servicesPage.coverage.staraBoleslavDesc': 'Stará Boleslav a okolní obce',
  
  // Proces
  'process.title': 'Jak to funguje',
  'process.subtitle': 'Jednoduše a rychle ve 4 krocích',
  'process.step1': 'Objednávka',
  'process.step1Desc': 'Objednejte online nebo telefonicky',
  'process.step2': 'Vyzvednutí',
  'process.step2Desc': 'Vyzvedneme prádlo na vaší adrese',
  'process.step3': 'Žehlení',
  'process.step3Desc': 'Profesionální žehlení našimi odborníky',
  'process.step4': 'Doručení',
  'process.step4Desc': 'Doručíme dokonale vyžehlené prádlo',
  
  // Proč my
  'why.title': 'Proč si vybrat nás',
  'why.quality': 'Špičková kvalita',
  'why.qualityDesc': 'Profesionální žehlení s důrazem na detail',
  'why.fast': 'Rychlá služba',
  'why.fastDesc': 'Expresní služba do 24 hodin',
  'why.convenient': 'Pohodlí',
  'why.convenientDesc': 'Vyzvednutí a doručení na vaší adrese',
  'why.affordable': 'Dostupné ceny',
  'why.affordableDesc': 'Transparentní ceník bez skrytých poplatků',
  
  // Ceník
  'pricing.title': 'Ceník',
  'pricing.subtitle': 'Transparentní ceny za všechny služby',
  'pricing.shirt': 'Košile/Halenka',
  'pricing.tshirt': 'Tričko',
  'pricing.pants': 'Kalhoty',
  'pricing.skirt': 'Sukně',
  'pricing.bedsheet': 'Prostěradlo',
  'pricing.duvet': 'Povlečení',
  'pricing.tablecloth': 'Ubrus',
  'pricing.towel': 'Ručník',
  'pricing.perPiece': 'za kus',
  'pricing.orderNow': 'Objednat nyní',
  
  // Členství
  'membership.title': 'Výhody členství',
  'membership.subtitle': 'Ušetřete s našimi členskými plány',
  'membership.calculator': 'Kalkulačka úspor',
  'membership.calculatorDesc': 'Spočítejte si, kolik ušetříte s členstvím',
  'membership.itemsPerMonth': 'Kusů za měsíc',
  'membership.withoutMembership': 'Bez členství',
  'membership.withMembership': 'S členstvím',
  'membership.monthlySavings': 'Měsíční úspora',
  'membership.yearlyTotal': 'Roční celkem',
  'membership.basic': 'Basic',
  'membership.standard': 'Standard',
  'membership.premium': 'Premium',
  'membership.unlimited': 'Unlimited',
  'membership.month': 'měsíc',
  'membership.pieces': 'kusů',
  'membership.unlimitedPieces': 'neomezeno',
  'membership.joinNow': 'Připojit se',
  'membership.mostPopular': 'Nejoblíbenější',
  'membership.basicDelivery': 'Dodání 72 hodin',
  'membership.premiumDelivery': 'Dodání 48 hodin',
  'membership.premiumExpress': 'Expresní dodání se slevou 10%',
  'membership.vipDelivery': 'Dodání 48 hodin',
  'membership.vipExpress': 'Expresní dodání ZDARMA',
  'membership.priceFor': 'Cena za',
  'membership.piecesPerMonth': 'kusů/měsíc',
  
  // Stránka členství - PŘIDÁNO
  'membership.hero.title': 'Členské plány',
  'membership.hero.subtitle': 'Vyberte si plán, který vám vyhovuje',
  'membership.plans.title': 'Vyberte si svůj plán',
  'membership.plans.subtitle': 'Flexibilní členství pro každého',
  'membership.howItWorks.title': 'Jak členství funguje',
  'membership.howItWorks.subtitle': 'Jednoduché kroky k pravidelným úsporám',
  
  // Recenze
  'testimonials.title': 'Recenze zákazníků',
  'testimonials.subtitle': 'Co o nás říkají naši zákazníci',
  
  // CTA
  'cta.title': 'Připraveni ušetřit čas?',
  'cta.subtitle': 'Objednejte si naši službu žehlení ještě dnes a užijte si dokonale vyžehlené prádlo',
  'cta.button': 'Objednat nyní',
  
  // Kontakt
  'contact.title': 'Kontaktujte nás',
  'contact.subtitle': 'Jsme tu pro vás',
  'contact.phone': 'Telefon',
  'contact.email': 'Email',
  'contact.hours': 'Otevírací doba',
  'contact.weekdays': 'Po - Pá: 8:00 - 18:00',
  'contact.weekend': 'So: 9:00 - 14:00',
  'contact.form.name': 'Jméno',
  'contact.form.email': 'Email',
  'contact.form.message': 'Zpráva',
  'contact.form.send': 'Odeslat zprávu',
  
  // Patička
  'footer.about': 'O nás',
  'footer.aboutText': 'Profesionální služba žehlení s vyzvednutím a doručením. Šetříme váš čas a energii.',
  'footer.quickLinks': 'Rychlé odkazy',
  'footer.services': 'Služby',
  'footer.pricing': 'Ceník',
  'footer.membership': 'Členství',
  'footer.partner': 'Partnerský program',
  'footer.legal': 'Právní informace',
  'footer.terms': 'Obchodní podmínky',
  'footer.cancellation': 'Storno podmínky',
  'footer.privacy': 'Zpracování osobních údajů',
  'footer.rights': 'Všechna práva vyhrazena',
  
  // Košík - Cart
  'cart.title': 'Nákupní košík',
  'cart.empty': 'Váš košík je prázdný',
  'cart.item': 'Položka',
  'cart.quantity': 'Množství',
  'cart.price': 'Cena',
  'cart.subtotal': 'Mezisoučet',
  'cart.memberPrice': 'Členská cena',
  'cart.savings': 'Ušetříte',
  'cart.checkout': 'Pokračovat k objednávce',
  'cart.continueShopping': 'Pokračovat v nákupu',
  'cart.remove': 'Odebrat',
  'cart.hangers': 'Ramínka',
  'cart.bags': 'Obaly',
  'cart.ownHangers': 'Vlastní ramínka/vak',
  'cart.free': 'ZDARMA',
  'cart.addHangers': 'Přidat ramínka',
  'cart.addBags': 'Přidat obaly',
  'cart.quickCart': 'Rychlý košík',
  'cart.items': 'položek',
  'cart.addService': 'Přidat službu:',
  'cart.membershipActive': 'Členství',
  'cart.monthlyUsage': 'Měsíční využití',
  'cart.used': 'Využito',
  'cart.of': 'z',
  'cart.thisMonth': 'tento měsíc',
  'cart.unlimited': 'neomezeno',
  'cart.shippingFree': 'Doprava ZDARMA',
  'cart.services': 'Služby:',
  'cart.memberSavings': 'Členská úspora:',
  'cart.discount': 'Sleva:',
  'cart.shipping': 'Doprava:',
  'cart.freeShipping': 'ZDARMA',
  'cart.membership': '(Členství)',
  'cart.almostFreeShipping': 'Ještě {amount} Kč do dopravy zdarma!',
  'cart.total': 'Celkem:',
  'cart.deliveryTime': 'Dodávka:',
  'cart.standardDelivery': 'Standardní dodávka: 72 hodin',
  'cart.expressDelivery': 'Expresní dodávka: do 48 hodin',
  'cart.pickupDelivery': 'Svoz a rozvoz: Pondělí - Pátek',
  'cart.specialRequest': 'Máte speciální požadavek nebo službu mimo ceník?',
  'cart.specialRequestPlaceholder': 'Např: Potřebuji vyžehlit svatební šaty, mám speciální látku...',
  'cart.maxChars': 'Maximálně 500 znaků',
  'cart.completeOrder': 'Dokončit objednávku',
  'cart.memberPricesApplied': 'Členské ceny aplikovány',
  'cart.noRegistration': 'Bez registrace • Rychlé vyřízení',
  'cart.perPiece': '/ kus',
  
  // Ramínka a obaly - Hangers & Packaging
  'cart.hangersPackaging': 'Ramínka a obaly',
  'cart.ownFree': 'Vlastní = ZDARMA',
  'cart.packaging': 'Obaly:',
  'cart.metalHanger': 'Kovové 5 Kč',
  'cart.ownBag': 'Vlastní vak ✨',
  'cart.plasticBag': 'Igelitový 15 Kč',
  'cart.reusableBag': 'Znovupoužitelný 89 Kč',
  'cart.pieces': 'ks',
  
  // Expresní dodávka - Express Delivery
  'cart.expressDeliveryOption': 'Expresní dodávka do 48h',
  'cart.expressDeliveryCost': '+500 Kč',
  'cart.standardDeliveryTime': 'Standardní dodací doba: 72 hodin',
  
  // Slevový kód - Discount Code
  'cart.haveDiscountCode': 'Máte slevový kód?',
  'cart.enterCode': 'Zadejte kód',
  'cart.applyCode': 'Použít',
  'cart.codeApplied': 'Kód:',
  'cart.discountValue': 'Sleva:',
  'cart.removeDiscount': 'Odstranit slevu',
  'cart.invalidCode': 'Neplatný slevový kód',
  'cart.codeNotYetValid': 'Tento kód ještě není platný',
  'cart.codeExpired': 'Tento kód již vypršel',
  'cart.codeExhausted': 'Tento kód již byl vyčerpán',
  'cart.minOrderAmount': 'Minimální částka objednávky: {amount} Kč',
  'cart.errorValidatingCode': 'Chyba při ověřování kódu',
  
  // Upgrade členství - Membership Upgrade
  'upgrade.limitExceeded': 'Překročíte měsíční limit!',
  'upgrade.orderExceeds': 'Vaše objednávka ({items} ks) překračuje zbývající limit ({remaining} ks).',
  'upgrade.considerUpgrade': 'Zvažte upgrade členství pro více kusů.',
  'upgrade.currentPlan': 'Aktuální plán:',
  'upgrade.usedThisMonth': 'Využito tento měsíc:',
  'upgrade.selectNewPlan': 'Vyberte nový plán:',
  'upgrade.recommended': 'Doporučeno',
  'upgrade.perMonth': '/ měsíc',
  'upgrade.continueWithout': 'Pokračovat bez upgrade',
  'upgrade.upgradeMembership': 'Upgradovat členství',
  'upgrade.upgrading': 'Upgraduji...',
  'upgrade.approaching': 'Blížíte se k měsíčnímu limitu!',
  'upgrade.remaining': 'Zbývá pouze {remaining} ks.',
  'upgrade.exceeds': 'Objednávka překračuje limit o {amount} ks!',
  'upgrade.upgradeNow': 'Upgradovat',
  
  // Využití členství
  'usage.title': 'Měsíční využití',
  'usage.used': 'Využito',
  'usage.remaining': 'Zbývá',
  'usage.warning': 'Blížíte se k měsíčnímu limitu!',
  'usage.exceeded': 'Vaše objednávka překračuje zbývající kusy',
  'usage.upgrade': 'Upgradovat členství',
  'usage.upgradeNow': 'Upgradovat nyní',
  
  // Objednávka - Checkout
  'checkout.title': 'Dokončení objednávky',
  'checkout.contactInfo': 'Kontaktní údaje',
  'checkout.deliveryAddress': 'Doručovací adresa',
  'checkout.paymentMethod': 'Způsob platby',
  'checkout.bankTransfer': 'Bankovní převod',
  'checkout.firstName': 'Jméno',
  'checkout.lastName': 'Příjmení',
  'checkout.email': 'Email',
  'checkout.phone': 'Telefon',
  'checkout.street': 'Ulice a číslo',
  'checkout.city': 'Město',
  'checkout.zip': 'PSČ',
  'checkout.notes': 'Poznámka k objednávce',
  'checkout.notesPlaceholder': 'Jakékoliv speciální požadavky...',
  'checkout.placeOrder': 'Odeslat objednávku',
  'checkout.processing': 'Zpracovávám...',
  'checkout.expressCheckout': 'Expresní objednávka',
  'checkout.completeWithoutRegistration': 'Dokončete objednávku bez registrace',
  'checkout.orderSummary': 'Souhrn objednávky:',
  'checkout.subtotal': 'Mezisoučet:',
  'checkout.discountCode': 'Slevový kód:',
  'checkout.discountAmount': 'Sleva:',
  'checkout.expressDeliveryYes': 'Ano - do 48h (+500 Kč)',
  'checkout.expressDeliveryNo': 'Ne - standardní 72h',
  'checkout.name': 'Jméno a příjmení',
  'checkout.location': 'Lokalita',
  'checkout.selectLocation': 'Vyberte lokalitu',
  'checkout.prague': 'Praha',
  'checkout.staraBoleslav': 'Stará Boleslav a okolí',
  'checkout.pickupAddress': 'Adresa vyzvednutí',
  'checkout.streetNumber': 'Ulice a číslo popisné',
  'checkout.preferredPickupTime': 'Preferovaný čas vyzvednutí',
  'checkout.selectTime': 'Vyberte čas',
  'checkout.morning': 'Dopoledne (8-12)',
  'checkout.afternoon': 'Odpoledne (12-16)',
  'checkout.noteSpecialRequests': 'Poznámka / Speciální požadavky',
  'checkout.notePlaceholder': 'Máte něco, co není v ceníku? Napište nám...',
  'checkout.chars': 'znaků',
  'checkout.importantInfo': 'Důležité informace:',
  'checkout.actualCount': 'Při svozu spočítáme skutečný počet kusů',
  'checkout.morePieces': 'Pokud bude více kusů → doúčtujeme při předání',
  'checkout.lessPieces': 'Pokud bude méně kusů → vrátíme rozdíl',
  'checkout.cancelFree': 'Storno více než 24h před svozem: zdarma',
  'checkout.cancelFee': 'Storno méně než 24h: storno poplatek 100% z ceny objednávky',
  'checkout.agreeWith': 'Souhlasím s',
  'checkout.termsConditions': 'obchodními podmínkami',
  'checkout.and': 'a',
  'checkout.privacyPolicy': 'zpracováním osobních údajů',
  'checkout.required': '*',
  'checkout.cancel': 'Zrušit',
  'checkout.submitOrder': 'Odeslat objednávku',
  'checkout.submitting': 'Odesílám...',
  'checkout.errorSubmitting': 'Chyba při odesílání. Zkuste to prosím znovu.',
  'checkout.orderReceived': 'Objednávka přijata! ✅',
  'checkout.contactSoon': 'Brzy vás budeme kontaktovat',
  'checkout.thankYou': 'Děkujeme za vaši objednávku!',
  'checkout.orderSubmitted': 'Vaše objednávka byla úspěšně odeslána',
  'checkout.whatNext': 'Co dál?',
  'checkout.contactForPickup': 'Brzy vás budeme kontaktovat pro upřesnění svozu',
  'checkout.countAtPickup': 'Při svozu spočítáme skutečný počet kusů',
  'checkout.adjustPrice': 'Případný rozdíl doúčtujeme/vrátíme při předání',
  'checkout.totalPrice': 'Celková cena:',
  'checkout.autoClose': 'Toto okno se automaticky zavře za chvíli...',
  
  // Účet
  'account.title': 'Můj účet',
  'account.membership': 'Členství',
  'account.orders': 'Objednávky',
  'account.settings': 'Nastavení',
  'account.logout': 'Odhlásit se',
  'account.noMembership': 'Žádné aktivní členství',
  'account.activeMembership': 'Aktivní členství',
  'account.validUntil': 'Platné do',
  'account.usageThisMonth': 'Využití tento měsíc',
  'account.orderHistory': 'Historie objednávek',
  'account.noOrders': 'Zatím žádné objednávky',
  'account.orderNumber': 'Objednávka č.',
  'account.date': 'Datum',
  'account.status': 'Stav',
  'account.amount': 'Částka',
  
  // Partner
  'partner.title': 'Partnerský program',
  'partner.subtitle': 'Vydělávejte s námi jako partner',
  'partner.howItWorks': 'Jak to funguje',
  'partner.benefits': 'Výhody',
  'partner.earnings': 'Kalkulačka výdělku',
  'partner.joinNow': 'Připojit se',
  'partner.successStories': 'Příběhy úspěchu',
  'partner.hero.title': 'Staňte se naším partnerem',
  'partner.hero.subtitle': 'Vydělávejte provize za každého zákazníka',
  'partner.info.title': 'Informace o programu',
  'partner.info.subtitle': 'Vše, co potřebujete vědět',
  'partner.video.title': 'Video tutoriály',
  'partner.video.subtitle': 'Naučte se, jak maximalizovat výdělky',
  
  // Společné
  'common.loading': 'Načítání...',
  'common.error': 'Chyba',
  'common.success': 'Úspěch',
  'common.cancel': 'Zrušit',
  'common.save': 'Uložit',
  'common.edit': 'Upravit',
  'common.delete': 'Smazat',
  'common.confirm': 'Potvrdit',
  'common.close': 'Zavřít',
  'common.back': 'Zpět',
  'common.next': 'Další',
  'common.previous': 'Předchozí',
  'common.search': 'Hledat',
  'common.filter': 'Filtrovat',
  'common.sort': 'Seřadit',
  'common.viewAll': 'Zobrazit vše',
  'common.showMore': 'Zobrazit více',
  'common.showLess': 'Zobrazit méně',
};

export default common;
